export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  // AI Nexus Menu
  'menu.首页': 'Home',
  'menu.关于我们': 'About Us',
  'menu.数据看板': 'Dashboard',
  'menu.数据看板.总览': 'Overview',
  'menu.数据看板.分析': 'Analytics',
  'menu.我的工作': 'Workspace',
  'menu.我的工作.智能体': 'Agents',
  'menu.我的工作.应用': 'Apps',
  'menu.我的智能体': 'My Agents',
  'menu.我的技能': 'My Skills',
  'menu.资料库': 'Resources',
  'menu.交易管理': 'Transactions',
  'menu.邀请记录': 'Invites',
  'menu.订阅与充值': 'Subscription & Recharge',
  'menu.订阅与充值.交易管理': 'Transactions',
  'menu.订阅与充值.订阅计划': 'Plans',
  'menu.订阅与充值.充值': 'Recharge',
  'menu.订阅与充值.支付': 'Payment',
  'menu.订阅与充值.PayPal 回调': 'PayPal Return',
  'menu.订阅与充值.支付结果': 'Payment Result',
  'menu.DOSSM 操作说明': 'DOSSM Guide',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
};
